import { call, put, takeEvery } from 'redux-saga/effects';
import moment from 'moment';
import api from '../../externals/costMaintenanceProxy';
import {
  VALIDATE_ITEMS_BY_SUPCS,
  receiveItemValidationResponse,
  REQUEST_COST_DATA,
  receiveCostData,
  REQUEST_BUSINESS_CENTER_DETAILS,
  receiveBusinessCenterDetails,
  REQUEST_PRICE_RECORD_TYPES,
  receivePriceRecordTypes,
  REQUEST_ADHOC_COST_FILE_IMPORT,
  SUBMIT_GENERATE_COST_REPORTS,
  receiveAdhocCostFileImportResponse,
  REQUEST_MULTIPLE_ADHOC_COST_FILE_IMPORT,
  receiveMultipleAdhocCostFileImportResponse,
  receiveModulePriceImport,
  REQUEST_MODULE_PRICE_IMPORT,
  REQUEST_ALL_MODULES,
  receiveAllModules,
  REQUEST_MODULE_PRICE_EXPORT,
  receiveModulePriceExport,
  receiveItemPrice,
  REQUEST_ITEM_PRICE,
  CREATE_MODULE_GROUP,
  receiveAllCommodities,
  REQUEST_ALL_COMMODITIES,
  CREATE_COMMODITY_GROUP,
  REQUEST_COMMODITY_DETAILS,
  receiveCommodityDetails,
  REQUEST_MODULE_GROUPS_ASSOCIATIONS,
  receiveModuleGroupsAssociations,
  receiveDeleteModuleGroup,
  REQUEST_MODULE_GROUP_UPDATE,
  receiveModuleGroupUpdate,
  REQUEST_MODULE_GROUP_DELETE,
  REQUEST_MODULE_GROUP_COMMODITY_ASSIGNMENT,
  receiveModuleGroupCommodityAssignment,
  receiveModuleGroupLoadingAreaAssignment,
  REQUEST_MODULE_GROUP_LOADING_AREA_ASSIGNMENT,
  receiveAllLoadingAreas,
  REQUEST_ALL_LOADING_AREAS,
  receiveCommodityGroupDelete,
  receiveCommodityGroupUpdate,
  REQUEST_COMMODITY_GROUP_UPDATE,
  REQUEST_COMMODITY_GROUP_DELETE,
  REQUEST_COMMODITY_GROUP_ITEM_ASSIGNMENT,
  receiveAllPriceModuleItems,
  REQUEST_ALL_PRICE_MODULE_ITEMS,
  receiveCommodityGroupItemAssignment,
  receiveLoadingAreaDetails,
  REQUEST_LOADING_AREA_DETAILS,
  receiveLoadingAreaDelete,
  REQUEST_LOADING_AREA_CREATE,
  REQUEST_LOADING_AREA_UPDATE,
  REQUEST_LOADING_AREA_DELETE,
  receiveLoadingAreaCreate,
  receiveCreateModuleGroup,
  receiveCreateCommodityGroup,
  REQUEST_MODULE_GROUP_REACTIVATE,
  receiveReactivateModuleGroup,
  REQUEST_COMMODITY_GROUP_REACTIVATE,
  receiveReactivateCommodityGroup,
  REQUEST_LOADING_AREA_REACTIVATE,
  receiveReactivateLoadingArea,
  receiveLoadingAreaUpdate,
  REQUEST_UPDATE_MODULE_PRICES,
  receiveUpdateModulePrices,
} from '../actions/costMaintenanceActions';
import { receiveRequestWithVariationDetails, receiveWorkspaceRequestActionResponse } from '../actions/workspaceActions';
import {
  receiveErrorItemsValidation,
  receiveErrorInCostDataFetch,
  receiveErrorInBusinessCentersFetch,
  receiveErrorInPriceRecordTypesFetch,
  receiveErrorInWorkspaceRequestActionChange,
  receiveErrorInAdhocCostFileImport,
  receiveErrorInModulePriceImport,
  receiveErrorInModulesFetch,
  receiveErrorInModulePriceExport,
  receiveErrorInItemPrice,
  receiveErrorInModuleGroupCreate,
  receiveErrorInCommoditiesFetch,
  receiveErrorInCommodityGroupCreate,
  receiveErrorInCommodityDetailsFetch,
  receiveErrorInModulesAssociationsFetch,
  receiveErrorInModuleGroupDelete,
  receiveErrorInModuleGroupUpdate,
  receiveErrorInLoadingAreasFetch,
  receiveErrorInCommodityGroupDelete,
  receiveErrorInCommodityGroupUpdate,
  receiveErrorInCommodityGroupItemAssignment,
  receiveErrorInPriceModuleItemsFetch,
  receiveErrorInModuleGroupReactivate,
  receiveErrorInCommodityGroupReactivate,
  receiveErrorInLoadingAreaUpdate,
  receiveErrorInLoadingAreaCreate,
  receiveErrorInLoadingAreaDetailsFetch,
  receiveErrorInLoadingAreaDelete,
  receiveErrorInLoadingAreaReactivate,
  receiveErrorInModulePricesUpdate,
} from '../actions/errorDialogActions';
import {
  ITEM_VALIDATION_ERROR,
  UNABLE_TO_LOAD_COST_DATA,
  UNABLE_TO_LOAD_BUSINESS_CENTERS,
  UNABLE_TO_LOAD_PRICE_RECORD_TYPES,
  WORKSPACE_REQUEST_UPDATE_ERROR,
  FILE_IMPORT_ERROR,
  UNABLE_TO_LOAD_MODULES,
  UNABLE_TO_EXPORT_MODULE_DETAILS,
  UNABLE_TO_LOAD_ITEM_PRICE,
  PRICE_UPLOAD_FILE_SUBMITTED,
  UNABLE_TO_CREATE_MODULE_GROUP,
  UNABLE_TO_LOAD_COMMODITIES,
  UNABLE_TO_CREATE_COMMODITY_GROUP,
  UNABLE_TO_LOAD_COMMODITY_DETAILS,
  UNABLE_TO_LOAD_MODULE_GROUPS_ASSOCIATIONS,
  UNABLE_TO_DELETE_MODULE_GROUP,
  UNABLE_TO_UPDATE_MODULE_GROUP,
  UNABLE_TO_LOAD_LOADING_AREAS,
  UNABLE_TO_DELETE_COMMODITY_GROUP,
  UNABLE_TO_UPDATE_COMMODITY_GROUP,
  UNABLE_TO_LOAD_PRICE_MODULE_ITEMS,
  UNABLE_TO_REACTIVATE_MODULE_GROUP,
  UNABLE_TO_REACTIVATE_COMMODITY_GROUP,
  UNABLE_TO_REACTIVATE_LOADING_AREA,
  UNABLE_TO_LOAD_LOADING_AREA_DETAILS,
  UNABLE_TO_UPDATE_LOADING_AREA,
  UNABLE_TO_CREATE_LOADING_AREA,
  UNABLE_TO_DELETE_LOADING_AREA,
  UNABLE_TO_UPDATE_MODULE_PRICES,
} from '../../helpers/messageConstant';
import { convertToCSV, downloadCSV } from '../../util/fileUtils';
import { DATETIME_FORMAT, PRICE_UPLOAD_TEMPLATE_COLUMNS } from '../../helpers/constants';
/**
 * Cost Maintenance Saga: will be fired on cost data maintenance related actions
 *
 * @author ysum5308
 */
export function* validateItemsBySupcs({ data }) {
  try {
    const responseData = yield call(api.validateItemsBySupcs, data);
    yield put(receiveItemValidationResponse(responseData));
  } catch (e) {
    yield put(receiveErrorItemsValidation(ITEM_VALIDATION_ERROR));
  }
}

export function* fetchCostDataRecords({ data }) {
  try {
    const costDataRecords = yield call(api.fetchCostDataRecords, data);
    yield put(receiveCostData(costDataRecords));
  } catch (e) {
    yield put(receiveErrorInCostDataFetch(UNABLE_TO_LOAD_COST_DATA));
  }
}

export function* importAdhocCostFile({ data }) {
  try {
    const response = yield call(api.importAdhocCostFile, data);
    const adhocCostFileImportResponse = response.data;
    if (adhocCostFileImportResponse.error) {
      yield put(receiveErrorInAdhocCostFileImport(adhocCostFileImportResponse.errorMessage));
    } else {
      adhocCostFileImportResponse.fileName = response.fileName;
      yield put(receiveAdhocCostFileImportResponse(adhocCostFileImportResponse));
    }
  } catch (e) {
    yield put(receiveErrorInAdhocCostFileImport(FILE_IMPORT_ERROR));
  }
}

export function* importMultipleAdhocCostFiles({ data }) {
  try {
    const fileProcessList = yield call(
      api.submitVendorPriceImportFiles, data
    );
    yield put(receiveMultipleAdhocCostFileImportResponse(fileProcessList));
  } catch (e) {
    yield put(receiveErrorInAdhocCostFileImport(FILE_IMPORT_ERROR));
  }
}

export function* fetchBusinessCenters({ data }) {
  try {
    const { suvcs } = data;
    const businessCenters = yield call(api.fetchBusinessCenters, suvcs);
    yield put(receiveBusinessCenterDetails(businessCenters));
  } catch (e) {
    yield put(receiveErrorInBusinessCentersFetch(UNABLE_TO_LOAD_BUSINESS_CENTERS));
  }
}

export function* fetchPriceRecordTypes({ data }) {
  try {
    const priceRecordTypes = yield call(api.fetchPriceRecordTypes, data);
    yield put(receivePriceRecordTypes(priceRecordTypes));
  } catch (e) {
    yield put(receiveErrorInPriceRecordTypesFetch(UNABLE_TO_LOAD_PRICE_RECORD_TYPES));
  }
}

function createCostMapsForCostRecordsAndOutputCostRecords(variationResponse) {
  const costImportRecordsMap = {};
  const outputCostRecordsMap = {};
  const { outputCostRecords, costImportRecords } = variationResponse;

  if (outputCostRecords) {
    outputCostRecords.forEach((outputCostRecord) => {
      outputCostRecordsMap[outputCostRecord.lineItemId] = { ...outputCostRecord };
    });
  }
  if (costImportRecords) {
    costImportRecords.forEach((costImportRecord) => {
      const { lineItemId } = costImportRecord;
      costImportRecordsMap[lineItemId] = { ...costImportRecord };
      if (!outputCostRecordsMap[lineItemId]) {
        outputCostRecordsMap[lineItemId] = { ...costImportRecord, costRecordStatus: costImportRecord.status, rejected: true };
      }
    });
  }
  variationResponse.costImportRecordsMap = costImportRecordsMap;
  variationResponse.outputCostRecordsMap = outputCostRecordsMap;
}

export function* submitGenerateCostReports({ data }) {
  const { showConfirmationDialog, rowIdMap, ...params } = data;
  try {
    const variationResponse = yield call(api.submitGenerateCostReports, params);
    createCostMapsForCostRecordsAndOutputCostRecords(variationResponse);
    yield put(receiveRequestWithVariationDetails({
      ...variationResponse, rowIdMap, isVariationReportGenerated: true
    }));
    if (showConfirmationDialog) {
      yield put(receiveWorkspaceRequestActionResponse({ ...variationResponse, message: 'Successfully triggered cost report generation' }));
    }
  } catch (e) {
    yield put(receiveErrorInWorkspaceRequestActionChange(WORKSPACE_REQUEST_UPDATE_ERROR));
  }
}

export function* importModulePrice({ data }) {
  try {
    yield call(api.importModulePrice, data);
    yield put(receiveModulePriceImport(PRICE_UPLOAD_FILE_SUBMITTED));
  } catch (e) {
    yield put(receiveErrorInModulePriceImport(FILE_IMPORT_ERROR));
  }
}

export function* exportModulePrice({ data }) {
  try {
    let moduleDetails = yield call(api.exportModulePrice, data);
    moduleDetails = moduleDetails.map((module) => ({
      ...module,
      start_date: moment().format(DATETIME_FORMAT.MMDDYYYY),
    }));
    downloadCSV(convertToCSV(moduleDetails, PRICE_UPLOAD_TEMPLATE_COLUMNS), 'price_module');
    yield put(receiveModulePriceExport());
  } catch (e) {
    yield put(receiveErrorInModulePriceExport(UNABLE_TO_EXPORT_MODULE_DETAILS));
  }
}

export function* fetchAllModules() {
  try {
    const modules = yield call(api.fetchAllModules);
    yield put(receiveAllModules(modules));
  } catch (e) {
    yield put(receiveErrorInModulesFetch(UNABLE_TO_LOAD_MODULES));
  }
}

export function* getItemPrice({ data }) {
  try {
    const itemPrice = yield call(api.getItemPrice, data);
    yield put(receiveItemPrice(itemPrice));
  } catch (e) {
    yield put(receiveErrorInItemPrice(UNABLE_TO_LOAD_ITEM_PRICE));
  }
}

export function* createModuleGroup({ data }) {
  try {
    const created = yield call(api.createModuleGroup, data);
    yield put(receiveCreateModuleGroup({ id: created.groupId }));
    yield call(fetchAllModules);
  } catch (e) {
    const errorMessage = e.response?.data ? e.response?.data : UNABLE_TO_CREATE_MODULE_GROUP;
    yield put(receiveErrorInModuleGroupCreate(errorMessage));
  }
}

export function* fetchAllCommodities() {
  try {
    const commodities = yield call(api.fetchAllCommodities);
    yield put(receiveAllCommodities(commodities));
  } catch (e) {
    yield put(receiveErrorInCommoditiesFetch(UNABLE_TO_LOAD_COMMODITIES));
  }
}

export function* createCommodityGroup({ data }) {
  try {
    const created = yield call(api.createCommodityGroup, data);
    yield put(receiveCreateCommodityGroup({ id: created.commCodeId }));
    yield call(fetchAllCommodities);
  } catch (e) {
    const errorMessage = e.response?.data ? e.response?.data : UNABLE_TO_CREATE_COMMODITY_GROUP;
    yield put(receiveErrorInCommodityGroupCreate(errorMessage));
  }
}

export function* fetchModuleGroupsAssociations({ data }) {
  try {
    const modules = yield call(api.fetchModuleGroupsAssociations, data);
    yield put(receiveModuleGroupsAssociations(modules));
  } catch (e) {
    const errorMessage = e.response?.data ? e.response?.data : UNABLE_TO_LOAD_MODULE_GROUPS_ASSOCIATIONS;
    yield put(receiveErrorInModulesAssociationsFetch(errorMessage));
  }
}

export function* deleteModuleGroup({ data }) {
  try {
    yield call(api.deleteModuleGroup, data);
    yield call(fetchAllModules);
    yield put(receiveDeleteModuleGroup(data));
  } catch (e) {
    const errorMessage = e.response?.data ? e.response?.data : UNABLE_TO_DELETE_MODULE_GROUP;
    yield put(receiveErrorInModuleGroupDelete(errorMessage));
  }
}

export function* updateModuleGroup({ data, moduleId }) {
  try {
    const updatedModule = yield call(api.updateModuleGroup, moduleId, data);
    yield call(fetchAllModules);
    yield put(receiveModuleGroupUpdate(updatedModule));
  } catch (e) {
    const errorMessage = e.response?.data ? e.response?.data : UNABLE_TO_UPDATE_MODULE_GROUP;
    yield put(receiveErrorInModuleGroupUpdate(errorMessage));
  }
}

export function* moduleGroupCommodityAssignment({ data, moduleId }) {
  try {
    yield call(api.moduleGroupCommodityAssignment, moduleId, data);
    const modules = yield call(api.fetchModuleGroupsAssociations, { moduleIds: [moduleId] });
    yield put(receiveModuleGroupCommodityAssignment({ ...data, module: modules[0] }));
  } catch (e) {
    const errorMessage = e.response?.data ? e.response?.data : UNABLE_TO_UPDATE_MODULE_GROUP;
    yield put(receiveErrorInModuleGroupUpdate(errorMessage));
  }
}

export function* moduleGroupLoadingAreaAssignment({ data, moduleId }) {
  try {
    yield call(api.moduleGroupLoadingAreaAssignment, moduleId, data);
    const modules = yield call(api.fetchModuleGroupsAssociations, { moduleIds: [moduleId] });
    yield put(receiveModuleGroupLoadingAreaAssignment({ ...data, module: modules[0] }));
  } catch (e) {
    const errorMessage = e.response?.data ? e.response?.data : UNABLE_TO_UPDATE_MODULE_GROUP;
    yield put(receiveErrorInModuleGroupUpdate(errorMessage));
  }
}

export function* fetchAllLoadingAreas() {
  try {
    const loadingAreas = yield call(api.fetchAllLoadingAreas);
    yield put(receiveAllLoadingAreas(loadingAreas));
  } catch (e) {
    const errorMessage = e.response?.data ? e.response?.data : UNABLE_TO_LOAD_LOADING_AREAS;
    yield put(receiveErrorInLoadingAreasFetch(errorMessage));
  }
}

export function* requestCommodityDetails({ data }) {
  try {
    const commodityDetails = yield call(api.requestCommodityDetails, data);
    yield put(receiveCommodityDetails(commodityDetails));
  } catch (e) {
    yield put(receiveErrorInCommodityDetailsFetch(UNABLE_TO_LOAD_COMMODITY_DETAILS));
  }
}

export function* deleteCommodityGroup({ comcodeId }) {
  try {
    yield call(api.deleteCommodityGroup, comcodeId);
    yield call(fetchAllCommodities);
    yield put(receiveCommodityGroupDelete(comcodeId));
    yield put(receiveCommodityDetails(undefined));
  } catch (e) {
    const errorMessage = e.response?.data ? e.response?.data : UNABLE_TO_DELETE_COMMODITY_GROUP;
    yield put(receiveErrorInCommodityGroupDelete(errorMessage));
  }
}

export function* updateCommodityGroup({ data, comcodeId }) {
  try {
    const updatedCommodityGroup = yield call(api.updateCommodityGroup, comcodeId, data);
    yield put(receiveCommodityGroupUpdate(updatedCommodityGroup));
  } catch (e) {
    const errorMessage = e.response?.data ? e.response?.data : UNABLE_TO_UPDATE_COMMODITY_GROUP;
    yield put(receiveErrorInCommodityGroupUpdate(errorMessage));
  }
}

export function* fetchAllPriceModuleItems() {
  try {
    const items = yield call(api.fetchAllPriceModuleItems);
    yield put(receiveAllPriceModuleItems(items));
  } catch (e) {
    yield put(receiveErrorInPriceModuleItemsFetch(UNABLE_TO_LOAD_PRICE_MODULE_ITEMS));
  }
}

export function* commodityGroupItemAssignment({ data, comcodeId }) {
  try {
    yield call(api.commodityGroupItemAssignment, comcodeId, data);
    yield put(receiveCommodityGroupItemAssignment());
    yield call(requestCommodityDetails, { data: { comcode_id: comcodeId } });
  } catch (e) {
    const errorMessage = e.response?.data ? e.response?.data : UNABLE_TO_UPDATE_COMMODITY_GROUP;
    yield put(receiveErrorInCommodityGroupItemAssignment(errorMessage));
  }
}

export function* getLoadingAreaDetails({ data }) {
  try {
    const loadingArea = yield call(api.getLoadingAreaDetails, data);
    yield put(receiveLoadingAreaDetails(loadingArea));
  } catch (e) {
    yield put(receiveErrorInLoadingAreaDetailsFetch(UNABLE_TO_LOAD_LOADING_AREA_DETAILS));
  }
}

export function* deleteLoadingArea({ loadingAreaId }) {
  try {
    yield call(api.deleteLoadingArea, loadingAreaId);
    yield call(fetchAllLoadingAreas);
    yield put(receiveLoadingAreaDelete(loadingAreaId));
    yield put(receiveLoadingAreaDetails(undefined));
  } catch (e) {
    const errorMessage = e.response?.data ? e.response?.data : UNABLE_TO_DELETE_LOADING_AREA;
    yield put(receiveErrorInLoadingAreaDelete(errorMessage));
  }
}

export function* updateLoadingArea({ data, loadingAreaId }) {
  try {
    const updatedLoadingArea = yield call(api.updateLoadingArea, loadingAreaId, data);
    yield put(receiveLoadingAreaDetails(updatedLoadingArea));
    yield put(receiveLoadingAreaUpdate(updatedLoadingArea));
  } catch (e) {
    const errorMessage = e.response?.data ? e.response?.data : UNABLE_TO_UPDATE_LOADING_AREA;
    yield put(receiveErrorInLoadingAreaUpdate(errorMessage));
  }
}

export function* createLoadingArea({ data }) {
  try {
    const { loadingAreaId } = yield call(api.createLoadingArea, data);
    const loadingArea = yield call(api.getLoadingAreaDetails, { loading_area_id: loadingAreaId });
    yield put(receiveLoadingAreaCreate(loadingArea));
  } catch (e) {
    const errorMessage = e.response?.data ? e.response?.data : UNABLE_TO_CREATE_LOADING_AREA;
    yield put(receiveErrorInLoadingAreaCreate(errorMessage));
  }
}

export function* reactivateModuleGroup({ data }) {
  try {
    const reactivateResponse = yield call(api.reactivateModuleGroup, data);
    yield call(fetchAllModules);
    yield put(receiveReactivateModuleGroup(reactivateResponse));
  } catch (e) {
    const errorMessage = e.response?.data ? e.response?.data : UNABLE_TO_REACTIVATE_MODULE_GROUP;
    yield put(receiveErrorInModuleGroupReactivate(errorMessage));
  }
}

export function* reactivateCommodityGroup({ data }) {
  try {
    const reactivateResponse = yield call(api.reactivateCommodityGroup, data);
    yield call(fetchAllCommodities);
    yield put(receiveReactivateCommodityGroup(reactivateResponse));
  } catch (e) {
    const errorMessage = e.response?.data ? e.response?.data : UNABLE_TO_REACTIVATE_COMMODITY_GROUP;
    yield put(receiveErrorInCommodityGroupReactivate(errorMessage));
  }
}

export function* reactivateLoadingArea({ data }) {
  try {
    const reactivateResponse = yield call(api.reactivateLoadingArea, data);
    yield call(fetchAllLoadingAreas);
    yield put(receiveReactivateLoadingArea(reactivateResponse));
  } catch (e) {
    const errorMessage = e.response?.data ? e.response?.data : UNABLE_TO_REACTIVATE_LOADING_AREA;
    yield put(receiveErrorInLoadingAreaReactivate(errorMessage));
  }
}

export function* updateModulePrices({ data }) {
  const { prices, filter } = data;
  try {
    yield call(api.updateModulePrices, prices);
    yield call(getItemPrice, { data: filter });
    yield put(receiveUpdateModulePrices());
  } catch (e) {
    const errorMessage = e.response?.data ? e.response?.data : UNABLE_TO_UPDATE_MODULE_PRICES;
    yield put(receiveErrorInModulePricesUpdate(errorMessage));
  }
}

export function* costMaintenanceSaga() {
  yield takeEvery(VALIDATE_ITEMS_BY_SUPCS, validateItemsBySupcs);
  yield takeEvery(REQUEST_COST_DATA, fetchCostDataRecords);
  yield takeEvery(REQUEST_ADHOC_COST_FILE_IMPORT, importAdhocCostFile);
  yield takeEvery(REQUEST_MULTIPLE_ADHOC_COST_FILE_IMPORT, importMultipleAdhocCostFiles);
  yield takeEvery(REQUEST_BUSINESS_CENTER_DETAILS, fetchBusinessCenters);
  yield takeEvery(REQUEST_PRICE_RECORD_TYPES, fetchPriceRecordTypes);
  yield takeEvery(SUBMIT_GENERATE_COST_REPORTS, submitGenerateCostReports);
  yield takeEvery(REQUEST_MODULE_PRICE_IMPORT, importModulePrice);
  yield takeEvery(REQUEST_MODULE_PRICE_EXPORT, exportModulePrice);
  yield takeEvery(REQUEST_ALL_MODULES, fetchAllModules);
  yield takeEvery(REQUEST_ITEM_PRICE, getItemPrice);
  yield takeEvery(CREATE_MODULE_GROUP, createModuleGroup);
  yield takeEvery(REQUEST_ALL_COMMODITIES, fetchAllCommodities);
  yield takeEvery(REQUEST_ALL_LOADING_AREAS, fetchAllLoadingAreas);
  yield takeEvery(CREATE_COMMODITY_GROUP, createCommodityGroup);
  yield takeEvery(REQUEST_COMMODITY_DETAILS, requestCommodityDetails);
  yield takeEvery(REQUEST_MODULE_GROUPS_ASSOCIATIONS, fetchModuleGroupsAssociations);
  yield takeEvery(REQUEST_MODULE_GROUP_UPDATE, updateModuleGroup);
  yield takeEvery(REQUEST_MODULE_GROUP_DELETE, deleteModuleGroup);

  yield takeEvery(REQUEST_MODULE_GROUP_COMMODITY_ASSIGNMENT, moduleGroupCommodityAssignment);
  yield takeEvery(REQUEST_MODULE_GROUP_LOADING_AREA_ASSIGNMENT, moduleGroupLoadingAreaAssignment);

  yield takeEvery(REQUEST_COMMODITY_GROUP_UPDATE, updateCommodityGroup);
  yield takeEvery(REQUEST_COMMODITY_GROUP_DELETE, deleteCommodityGroup);

  yield takeEvery(REQUEST_ALL_PRICE_MODULE_ITEMS, fetchAllPriceModuleItems);
  yield takeEvery(REQUEST_COMMODITY_GROUP_ITEM_ASSIGNMENT, commodityGroupItemAssignment);

  yield takeEvery(REQUEST_LOADING_AREA_DETAILS, getLoadingAreaDetails);
  yield takeEvery(REQUEST_LOADING_AREA_CREATE, createLoadingArea);
  yield takeEvery(REQUEST_LOADING_AREA_UPDATE, updateLoadingArea);
  yield takeEvery(REQUEST_LOADING_AREA_DELETE, deleteLoadingArea);

  yield takeEvery(REQUEST_MODULE_GROUP_REACTIVATE, reactivateModuleGroup);
  yield takeEvery(REQUEST_COMMODITY_GROUP_REACTIVATE, reactivateCommodityGroup);
  yield takeEvery(REQUEST_LOADING_AREA_REACTIVATE, reactivateLoadingArea);
  yield takeEvery(REQUEST_UPDATE_MODULE_PRICES, updateModulePrices);
}
